import { render, staticRenderFns } from "./quesSuccess72.vue?vue&type=template&id=49d845ac"
import script from "./quesSuccess72.vue?vue&type=script&lang=js"
export * from "./quesSuccess72.vue?vue&type=script&lang=js"
import style0 from "./quesSuccess72.vue?vue&type=style&index=0&id=49d845ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports